import React, { useEffect, useRef, useState } from "react";

import { getMessageList } from "../api/messageApi.js";
import SolidSpinnerIcon from "../assets/icons/SolidSpinnerIcon.jsx";
import Chat from "../components/Chat/index.jsx";

const ActiveChat = ({
  activeChat,
  setPreviousMessages,
  previousMessages,
  isFetchingResponse,
  userQueryAndReport,
  setDashboards
}) => {
  const [isChatLoading, setIsChatLoading] = useState(true);

  const activeChatBottomContainerRef = useRef(null);

  useEffect(() => {
    if (activeChat) {
      getMessageList({
        chatId: activeChat,
        setData: setPreviousMessages,
        setLoading: setIsChatLoading,
      });
    }
  }, [activeChat]);

  useEffect(() => {
    if (activeChat) {
      getMessageList({ chatId: activeChat, setData: setPreviousMessages });
    }
  }, [isFetchingResponse]);

  useEffect(() => {
    setTimeout(() => {
      activeChatBottomContainerRef.current?.scrollIntoView({ block: "end" });
    }, 100);
  }, [isChatLoading]);

  useEffect(() => {
    setTimeout(() => {
      activeChatBottomContainerRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }, 10);
  }, [previousMessages]);

  return (
    <div className="flex flex-9 items-center justify-center flex-col flex-1 overflow-auto">
      <div className="h-chatHeight overflow-hidden overflow-y-scroll w-full flex flex-col gap-10">
        {/* <Outlet /> */}
        {isChatLoading ? (
          <div className="w-full h-full flex justify-center items-center">
            <SolidSpinnerIcon className="animate-spin w-7 h-7" />
          </div>
        ) : (
          previousMessages?.map((message) => {
            return (
              <Chat
                key={message._id}
                question={message.user_text}
                reply={message}
                userQueryAndReport={userQueryAndReport}
                setDashboards={setDashboards}
              />
            );
          })
        )}
        <div
          style={{ minHeight: "10px" }}
          ref={activeChatBottomContainerRef}
          className="h-10 w-full"
        ></div>
      </div>
    </div>
  );
};

export default ActiveChat;
